import { EmojiEvents, Gavel, Groups as GroupsIcon, Logout, Menu as MenuIcon, MilitaryTech, PersonAdd, QuestionAnswer, RingVolume, Route as RouteIcon } from '@mui/icons-material';
import { AppBar, Avatar, Backdrop, Badge, Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Tooltip, Typography } from '@mui/material';
import axios from 'axios';
import React, { Component } from 'react';
import { BrowserRouter, Link, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import App from './App';
import Awards from './Awards';
import Buamarules from './Buamarules';
import Buddies from './Buddies';
import BuddiesConnect from './BuddiesConnect';
import Chatroom from './Chatroom';
import VideoBox from './Elements/VideoBox';
import Groups from './Groups';
import { setAuthToken } from './Hooks/setAuthToken';
import JoinBuamatog from './JoinBuamatog';
import Login from './Login';
import NoBuamatogForU from './NoBuamatogForU';
import Profile from './Profile';
import Register from './Register';
import history from './Routes/history';
import { Award, User } from './Types/Types';
import { buamatogVerificationKey } from './Types/Utility';
import Users from './Users';
import WaitForBuamatog from './WaitForBuamatog';
import { buamatogColors } from './theme';
import './index.css';

interface Props {

}
interface State {
    hasAccess: Boolean, 
    isLoggedIn: Boolean, 
    user: User | null,
    awards: Award[],
    allowHasselcall: boolean,
    showHasselcall: boolean,
    showPatchnotes: boolean,
    showIntro: boolean,
    messages: number,
    messagesSeen: number,
};

class Routing extends Component<Props, State> {
    fetchMessageCountInterval : number | undefined = undefined;

    constructor(props : Props) {
        super(props);

        const messages = parseInt(localStorage.getItem('message-count') ?? '0');
        const messagesSeen = parseInt(localStorage.getItem('message-count-seen') ?? '0');

        this.state={
            hasAccess: (localStorage.getItem(buamatogVerificationKey()) ? true: false),
            isLoggedIn: (localStorage.getItem('buamatog-access-token') ? true: false),
            user: null,
            awards: localStorage.getItem('awards') ? JSON.parse(localStorage.getItem('awards') ?? '[]') : [],
            allowHasselcall: localStorage.getItem('allow-hasselcall') ? true : false,
            showHasselcall: false,
            showPatchnotes: false,
            showIntro: localStorage.getItem('intro') ? false : true,
            messages: messages,
            messagesSeen: messagesSeen,
        }

        this.fetchMessageCountInterval = undefined;
    }
    
    componentDidMount() {
        this.updateState();
        history.listen(() => {
            this.updateState();
        });

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.onresize = () => {
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        document.addEventListener('update', () => this.updateGlobalUserState()); 
        document.addEventListener('update-awards', () => this.updateGlobalAwardsState()); 
        document.addEventListener('allow-hasselcall', () => this.allowHasselcall());
        document.addEventListener('update-messages-seen', () => this.updateMessageSeenState());
    }

    componentWillUnmount() {
        document.removeEventListener('update', () => this.updateGlobalUserState());
        document.removeEventListener('update-awards', () => this.updateGlobalAwardsState());
        document.removeEventListener('allow-hasselcall', () => this.allowHasselcall());
        document.removeEventListener('update-messages-seen', () => this.updateMessageSeenState());

        window.clearInterval(this.fetchMessageCountInterval);
    }

    allowHasselcall = () => {
        const hasHasselcall = localStorage.getItem('allow-hasselcall');
        if (!hasHasselcall) {
            this.setState({
                allowHasselcall: true,
            }, () => {
                localStorage.setItem('allow-hasselcall', (true).toString());  
            });
        }
    }

    updateState = () => {
        let change : State = Object.assign({}, {
            hasAccess: false,
            isLoggedIn: false,
            user: this.state.user,
            awards: this.state.awards,
            allowHasselcall: this.state.allowHasselcall,
            showHasselcall: this.state.showHasselcall,
            showPatchnotes: this.state.showPatchnotes,
            showIntro: localStorage.getItem('intro') ? false : true,
            messages: this.state.messages,
            messagesSeen: this.state.messagesSeen,
        });

        if (localStorage.getItem(buamatogVerificationKey())) {
            change.hasAccess = true;
            if (localStorage.getItem('buamatog-access-token')) {
                change.isLoggedIn = true;
            } else {
                change.user = null;
            }
        }
        const _self = this;
        _self.setState(change, () => {
            if (localStorage.getItem('buamatog-access-token')) {
                setAuthToken(localStorage.getItem('buamatog-access-token'));
                
                const { user } = _self.state;
                
                if (!user) {
                    this.updateGlobalUserState();
                }

                const { awards } = _self.state;
                if (awards.length === 0) {
                    this.updateGlobalAwardsState();
                }
            }
        });
    }

    updateGlobalUserState = () => {
        axios.get<User>('/user')
        .then(res => {
            const user = res.data;
            
            this.setState({
                user: user,
                messages: user.messages,
            }, () => {
                // window.clearInterval(_self.fetchMessageCountInterval);
                // _self.fetchMessageCountInterval = window.setInterval(() => {
                //     _self.updateMessageCountState();
                // }, 1000 * 60);
            });
        });
    }

    updateMessageSeenState = () => {
        const total = parseInt(localStorage.getItem('message-count') ?? '0');
        const seen = parseInt(localStorage.getItem('message-count-seen') ?? '0');

        this.setState({
            messages: total,
            messagesSeen: seen
        });
    }

    updateMessageCountState = () => {
        axios.get<{total:number}>('/message-count')
        .then(res => {
            const total = res.data.total;

            const seen = parseInt(localStorage.getItem('message-count-seen') ?? '0');

            localStorage.setItem('message-count', JSON.stringify(total));
            localStorage.setItem('message-count-seen', JSON.stringify(seen));

            this.setState({
                messages: total,
                messagesSeen: seen
            });
        });
    }

    updateGlobalAwardsState = () => {
        axios.get<Award[]>('/awards')
        .then(res => {
            localStorage.setItem('awards', JSON.stringify(res.data));
            this.setState({
                awards: res.data,
            });
        });
    }

    getGlobalUserState = () => {
        return this.state.user;
    }

    handleLogout = (e : React.MouseEvent) => {
        setAuthToken(null);
        setTimeout(() => {
            history.push('/login');
        }, 200);
    }

    handleOpenHasselcall = (e : React.MouseEvent) => {
        const { allowHasselcall } = this.state;
        if (allowHasselcall) {
            this.setState({
                showHasselcall: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showHasselcall: false,
                    });
                }, 3000);   
            });
        }
    }

    handleShowPatchnotes = (e : React.MouseEvent) => {
        this.setState({
            showPatchnotes: true,
        });
    }

    handleClosePatchnotes = (e : React.MouseEvent) => {
        this.setState({
            showPatchnotes: false,
        }, () => {
            localStorage.setItem('patchnotes', (true).toString());
        });
    }

    render() {
        const { user, awards, allowHasselcall, showHasselcall, showPatchnotes, showIntro } = this.state;

        const getAvatar = () => {
            const { user } = this.state;
            if (user) {
                if (user.image.startsWith('hoff')) {
                    return process.env.PUBLIC_URL + '/img/' + user.image;
                }
                return process.env.PUBLIC_URL + '/awards/' + user.image;
            }
            return undefined;
        }

        const getName = () => {
            if (user) {
                return user.username;
            }
            return undefined;
        }

        const getOpenMessages = () => {
            return undefined;
            // const { messages, messagesSeen } = this.state;
            // if (messages) {
            //     let diff = messages - messagesSeen;
            //     if (diff > 0) {
            //         return diff;
            //     }
            // }
            // return undefined;
        }

        const content = <>
            <Outlet />
        </>;

        const drawer = (
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', backgroundColor: buamatogColors.darkerGrey }}>
                <Box sx={{ display: 'grid', placeItems: 'center' }}>
                    <IconButton sx={{ p: 2, margin: 'auto', display: 'grid', placeItems: 'center', height: '176px', width: '176px' }} component={Link} to={'profile'}>
                        <Box>
                            <Avatar alt="Profil" src={getAvatar()} sx={{ height: 96, width: 96, m: 'auto' }}/>
                            <Typography textAlign={'center'} variant={'h6'} sx={{ p: 1, paddingBottom: 0 }}>{getName()}</Typography>
                        </Box>
                    </IconButton>
                </Box>
                <Box>
                    <List>
                        <ListItem>
                            <ListItemButton component={Link} to="/">
                                <ListItemIcon>
                                    <RouteIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Seitätour" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component={Link} to="/buddies">
                                <ListItemIcon>
                                    <PersonAdd/>
                                </ListItemIcon>
                                <ListItemText primary="Eppan G'sechn" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component={Link} to="/awarded">
                                <ListItemIcon>
                                    <MilitaryTech/>
                                </ListItemIcon>
                                <ListItemText primary="Ehrunga" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component={Link} to="/users">
                                <ListItemIcon>
                                    <EmojiEvents/>
                                </ListItemIcon>
                                <ListItemText primary="De Duschtigstn" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component={Link} to="/groups">
                                <ListItemIcon>
                                    <GroupsIcon/>
                                </ListItemIcon>
                                <ListItemText primary="Gruppen" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component={Link} to="/rules">
                                <ListItemIcon>
                                    <Gavel/>
                                </ListItemIcon>
                                <ListItemText primary="Buamaregeln" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
                <Box flexGrow={1}></Box>
                <Box flexShrink={1} sx={{ display: 'grid', placeItems: 'center', p: 5 }}>
                    <Button variant="contained" disabled={allowHasselcall ? false : true} onClick={this.handleOpenHasselcall}>
                        <Box>
                            <Box><RingVolume /></Box>
                            <Box>
                                Hasselcall
                            </Box>
                        </Box>
                    </Button>
                    {!allowHasselcall && <Box sx={{ color: 'grey' }}>Wenn de Zeit reif is!</Box>}
                </Box>
                <Box flexShrink={1} sx={{ display: 'grid', placeItems: 'center', p: 1 }}><Button  onClick={this.handleShowPatchnotes}>Wos geits?</Button></Box>
                <Box flexShrink={1} sx={{ display: 'grid', placeItems: 'center', p: 1 }}>
                    <Button variant="contained" startIcon={<Logout fontSize="inherit" />} onClick={this.handleLogout}>i schleich mi</Button>
                </Box>
            </Box>
          );

        const patchnotes = <Dialog
            open={showPatchnotes}
            onClose={this.handleClosePatchnotes}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ minWidth: '95vw' }}
        >
            <DialogTitle id="scroll-dialog-title">Buamatog 2025: Happy Buamatog</DialogTitle>
            <DialogContent dividers={true}>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                >
                    Hawidere! Bärig dasds wida do seits.<br/>
                    I hoff es seits a heuer wida motiviascht auf an duschtign Buamatog.<br/>
                    <br/>
                    <b>Wos is da Plan?</b><br/>
                    Dea Tog is do um a Gaudi z'hom.<br/>
                    Trefft's ench mit enchan Saufhaufn und hauts ench auße.<br/>
                    Schaugs dass a poor Ehrunga aufdaklaubs.<br/>
                    <br/>
                    <b>Whatsapp-Kanal</b><br/>
                    Bleibs aufn laufenden mitn neuen Whatsapp-Kanal.<br/>
                    <a href="https://whatsapp.com/channel/0029VbBDxQX5K3zLaEtIv93E" title="Whatsapp-Kanal: buamatog.at" target='_blank' style={{color:'white'}}>"buamatog.at"-Kanal</a>.<br/>
                    <br/>
                    <b>Wenns Probleme gib mitn iPhone</b><br/>
                    Unter Einstellungen &gt; Ortungsdienste measn allgemein aktiv sei.<br/>
                    Unter Einstellungen &gt; Ortungsdienste muas bei Safari bzw. dein Browser a auf "Beim Verwenden der App" oder "Nächstes mal fragen" eingstöht sei.<br/>
                    Unter Einstellungen &gt; Apps &gt; Safari bzw. dein Browser muas da Standort a aktiviert sei.<br/>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.handleClosePatchnotes}>Geil</Button>
                <Button onClick={this.handleClosePatchnotes}>Volle Geil!</Button>
            </DialogActions>
        </Dialog>;

        const intro = <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showIntro ? true : false}
        >
            <VideoBox src={process.env.PUBLIC_URL + '/hoff-greeting.mp4'} onClose={(e) => {
                this.setState({
                    showIntro: false,
                    showPatchnotes: localStorage.getItem('patchnotes') ? false : true,
                }, () => {
                    localStorage.setItem('intro', '1');
                });
            }}/>
        </Backdrop>;


          interface AuthenticatedProps {
            window?: () => Window
          }
        function AuthenticatedLayout(props : AuthenticatedProps) {
            const { window } = props;

            const [mobileOpen, setMobileOpen] = React.useState(false);

            const handleDrawerToggle = () => {
              setMobileOpen(!mobileOpen);
            };

            const drawerWidth = 250;

            const getLoaderGif = () => {
                const randomNumber = Math.floor(Math.random() * 8) + 1;

                return <img src={process.env.PUBLIC_URL + '/rescue-'+randomNumber+'.gif?year=2025'} style={{ height: '100%', maxWidth: '100%', opacity: 1, objectFit: 'scale-down' }}/>;
            }

            const container = window !== undefined ? () => window().document.body : undefined;
            return (
              <Container maxWidth="sm" sx={{ 
                    height: 'calc(100 * var(--vh))', 
                    paddingLeft: 'unset', 
                    paddingRight: 'unset', 
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '100%',
                    overflowY: 'auto',
                }}>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={showHasselcall ? true : false}
                    >
                        {getLoaderGif()}
                    </Backdrop>
                    {showIntro && intro}
                    {patchnotes}
                    <AppBar position="static" sx={{ backgroundColor: buamatogColors.darkerGrey }}>
                        <Toolbar>
                            <Box sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={handleDrawerToggle}
                                    sx={{ mr: 2 }}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Typography
                                    variant="h5"
                                    component={Link} 
                                    to={'/'}
                                    sx={{
                                        mr: 2,
                                        flexGrow: 1,
                                        fontFamily: 'monospace',
                                        fontWeight: 700,
                                        letterSpacing: '.3rem',
                                        color: 'inherit',
                                        textDecoration: 'none',
                                    }}
                                >
                                    BUAMATOG
                                </Typography>
                                <Box flexShrink={1}>
                                    <IconButton component={Link} to={"/chat"}>
                                        <Badge badgeContent={getOpenMessages()} color={"success"}>
                                            <QuestionAnswer/>
                                        </Badge>
                                    </IconButton>
                                </Box>
                                <Box flexShrink={1} sx={{ ml: 2 }}>
                                    <Tooltip title="Open settings">
                                        <IconButton sx={{ p: 0 }} component={Link} to={'profile'}>
                                            <Avatar alt="Profil" src={getAvatar()} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Toolbar>
                        <Drawer
                            container={container}
                            variant="temporary"
                            open={mobileOpen}
                            onClick={handleDrawerToggle}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                            sx={{
                                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: buamatogColors.darkerGrey },
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </AppBar>
                    {content}
                </Container>
            );
          }
          
          function LoginLayout() {
            return (
                <Container maxWidth="sm" sx={{ 
                    height: 'calc(100 * var(--vh))', 
                    paddingLeft: 'unset', 
                    paddingRight: 'unset', 
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Outlet />
                </Container>
            );
          }
          
          const isVerified = () => {
            const { hasAccess } = this.state;
            if (hasAccess) {
              return true;
            }
            // return true;
            return false;
          }
          
          const isAuthenticated = () => {
            const { isLoggedIn } = this.state;
            if (isLoggedIn) {
              return true;
            }
            return false;
          }          

          const isBuamatogAlready = () => {
            const overwrite = localStorage.getItem('buamatog-is-wonn-i-sog-2025');
            if (overwrite) {
                return true;
            }

            const currentDate = new Date()
            const year = currentDate.getFullYear();
            const buamatog = new Date(year+'-12-26T00:00:00');
            const dayAfterBuamatog = new Date(year+'-12-27T00:00:00');

            return currentDate.toDateString() == buamatog.toDateString() || currentDate.toDateString() == dayAfterBuamatog.toDateString();
          }

        return (
            <BrowserRouter>
                <Routes>
                    {isVerified() && 
                    ((isAuthenticated() && isBuamatogAlready())
                        ? <Route path="/" element={<AuthenticatedLayout />}>
                        <Route index element={<App />} />
                        <Route path="profile" element={<Profile user={user} awards={awards}/>} />
                        <Route path="buddies" element={<Buddies user={user}/>} />
                        <Route path="/buddies/:connectUserId" element={<BuddiesConnect user={user}/>} />
                        <Route path="users" element={<Users />} />
                        <Route path="groups" element={<Groups user={user}/>} />
                        <Route path="awarded" element={<Awards awards={awards} user={user}/>} />
                        <Route path="rules" element={<Buamarules/>}></Route>
                        <Route path="chat" element={<Chatroom user={user}/>}></Route>
                        <Route path="*" element={<Navigate to={'/'}/>}/>
                        </Route>
                        : <Route path="/" element={<LoginLayout />}>
                            {isBuamatogAlready()
                                ? <>
                                    <Route index element={<Login />} />
                                    <Route path="login" element={<Login />} />
                                    <Route path="register" element={<Register />} />
                                    <Route path="*" element={<Navigate to={'/login'}/>}/>
                                </>
                                : <>
                                    <Route index element={<WaitForBuamatog/>}/>
                                    <Route path="*" element={<WaitForBuamatog/>}/>
                                </>
                            }
                        </Route>)
                    }
                    <Route path="/join" element={<JoinBuamatog/>}/>
                    <Route path="*" element={<NoBuamatogForU/>}/>
                </Routes>
            </BrowserRouter>
        );
    }
}
export default Routing;